import { QuizzesList as QuizzesListComponent } from './QuizzesList.component';
import { connector } from './QuizzesList.connector';

export const QuizzesList = connector(QuizzesListComponent);
